export default __webpack_public_path__ + "static/media/tj.2d21b4a3.svg";